import { render, staticRenderFns } from "./TheCartPage.vue?vue&type=template&id=525f6d50&"
import script from "./TheCartPage.vue?vue&type=script&lang=js&"
export * from "./TheCartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports